import React, { Fragment, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Stack,
} from "@mui/material";
import FilterSunlight from "../Filter/Sunlight";
import FilterWidth from "../Filter/Width";
import FloweringTime from "./FloweringTime";
import FilterFloweringTime from "../Filter/FloweringTime";
import FilterHeight from "../Filter/Height";
import FilterWater from "../Filter/Water";
import FilterSoil from "../Filter/Soil";
import FilterCategory from "../Filter/Category";

const FilterModal = ({ filters, onSubmit }) => {
  const [open, setOpen] = useState(false);
  const [sunlight, setSunlight] = useState(filters.sunlight || []);
  const [width, setWidth] = useState(filters.width || []);
  const [floweringTime, setFloweringTime] = useState(
    filters.floweringTime || []
  );
  const [height, setHeight] = useState(filters.height || []);
  const [water, setWater] = useState(filters.water || []);
  const [soil, setSoil] = useState(filters.soil || []);
  const [category, setCategory] = useState(filters.category || []);

  const handleSubmit = (event) => {
    if (event) event.preventDefault();
    onSubmit({
      sunlight,
      floweringTime,
      category,
      soil,
      water,
      width,
      height,
    });

    onClose();
  };

  const onClose = () => {
    setOpen(false);
  };

  const handleReset = () => {
    // reset all filters
    setSunlight([]);
    setFloweringTime([]);
    setWidth([]);
    setHeight([]);
    setWater([]);
    setSoil([]);
    setCategory([]);

    // submit
    handleSubmit();
  };

  return (
    <Fragment>
      <Button onClick={() => setOpen(true)}>Filter</Button>

      <Dialog
        open={open}
        onClose={onClose}
        fullScreen
        style={{
          backgroundColor: "white",
        }}
      >
        <DialogTitle>Filters</DialogTitle>
        <DialogContent>
          <form onSubmit={handleSubmit}>
            <Stack direction="column" spacing={2}>
              <FilterSunlight
                value={sunlight}
                onChange={(value) => setSunlight(value)}
              />
              <FilterFloweringTime
                value={floweringTime}
                onChange={(value) => setFloweringTime(value)}
              />
              <FilterWidth
                value={width}
                onChange={(value) => setWidth(value)}
              />
              <FilterHeight
                value={height}
                onChange={(value) => setHeight(value)}
              />
              <FilterWater
                value={water}
                onChange={(value) => setWater(value)}
              />
              <FilterSoil value={soil} onChange={(value) => setSoil(value)} />
              <FilterCategory
                value={category}
                onChange={(value) => setCategory(value)}
              />
            </Stack>
          </form>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleReset}>Reset</Button>
          <Button onClick={onClose}>Cancel</Button>
          <Button onClick={handleSubmit} variant="contained">
            Apply Filters
          </Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

export default FilterModal;
